import { IonPopover } from '@ionic/angular';

export type DatePickerDismissStatus = 'cancel' | 'confirm';

export const handleDatePickerDismiss = async (
  popoverGC: IonPopover,
  status: DatePickerDismissStatus,
  onConfirm: () => unknown | Promise<unknown>,
): Promise<void> => {
  if (status === 'confirm') {
    await onConfirm();
    return;
  }

  await popoverGC.dismiss(undefined, 'cancel');
};

